import { env } from '../../config';
import {
	Route,
} from 'react-router-dom';

import HomeLanding from './HomeLanding';
import ScreenPage from '../Screen/ScreenPage';

import ContentManagementPage from '../ContentManagement/ContentManagementPage'
import CustomersPage from '../Customers/CustomersPage';
import ForesightPage from '../Foresight/ForesightPage';
import LocationsPage from '../Locations/LocationsPage';
import MobilityScore from '../MobilityScore/MobilityScore';
import ReportAnalyticsPage from '../ReportAnalytics/ReportAnalyticsPage';
import JourneyPage from '../Journey/JourneyPage';
import JourneyPlaylistPage from '../Journey/JourneyPlaylistPage';
import UsersPage from '../Users/UsersPage';
import { userHasPermission } from '../../utils';

import logo from '../../images/logos/af-logo.svg'

import sidebarNavItems from '../../constants/sidebarNavItems.json';

const ContentSwitcher = ({
	className,
	lang,
	userData,
	customer,
	permissions,
	locations,
	handleContentModalOpen,
}) => {

	// Flatten nav items
	let allPages = [];
	sidebarNavItems.forEach((parent) => {
		if (parent.subNavItems) {
			parent.subNavItems.forEach((subItem) => {
				allPages.push(subItem);
			})
		}
		else {
			allPages.push(parent);
		}
	});
 
	// Assign "page" components to the nav list
	const pageRoutes = allPages.map((page) => {	
		if (page.component == 'HomeLanding') {
			page.jsx = <HomeLanding lang={lang} userData={userData}/>
		}
		else if (page.component == 'ScreenPage') {
			page.jsx = <ScreenPage lang={lang} userData={userData} permissions={permissions} />
		}
		else if (page.component == 'MobilePage') {
			page.jsx = <ScreenPage lang={lang} userData={userData}/>
		}
		else if (page.component == 'ReportAnalyticsPage') {
			page.jsx = <ReportAnalyticsPage lang={lang} accessToken={userData.accessToken}/>
		}
		else if (page.component == 'ForesightPage') {
			page.jsx = <ForesightPage lang={lang} accessToken={userData.accessToken}/>
		}
		else if (page.component == 'MobilityScore') {
			page.jsx = <MobilityScore lang={lang} userData={userData} allPermissions={permissions} />
		}
		else if (page.component == 'UsersPage') {
			page.jsx = <UsersPage lang={lang} userData={userData}/>
		}
		else if (page.component == 'LocationsPage') {
			page.jsx = <LocationsPage lang={lang} userData={userData}/>
		}
		else if (page.component == 'CustomersPage') {
			page.jsx = <CustomersPage lang={lang} userData={userData}/>
		}
		
		// if (!page.disabled) {
		// 	page.jsx = components[page.component];
		// } else {
		// 	//TODO Temporary measure as Foresight goes into the above if statement
		// 	//but for some reason keeps on going out on in this else statement
			
		// 	page.jsx = <ForesightPage lang={lang} accessToken={userData.accessToken}/>		
		// }

		return page;
	});

	return (
		<div className={`Content ${className || ''}`}>
			<div className="header-logo">
				<img id="actionfigure-logo" src={logo} alt="action figure logo"/>
			</div>
			<div className="container">
					{pageRoutes.map((page) => {
						return <Route key={page.key} exact={true} path={page.path}>
							{
								page.component == 'HomeLanding'
								? <HomeLanding
									lang={lang}
									userData={userData}
									customer={customer}
									locations={locations}
									allPermissions={permissions}
								/>
								: page.component == 'ScreenPage' && userHasPermission('screen', permissions)
								? <ScreenPage
									lang={lang}
									userData={userData}
									access={'screen'}
									customer={customer}
									permissions={permissions}
									locations={locations}
									handleContentModalOpen={handleContentModalOpen} />
								: page.component == 'MobilePage' && userHasPermission('screen', permissions)
								? <ScreenPage
									lang={lang}
									userData={userData}
									access={'mobile'}
									customer={customer}
									permissions={permissions}
									locations={locations} 
									handleContentModalOpen={handleContentModalOpen} />
								: page.component == 'ContentManagementPage' && userHasPermission('playlistFull', permissions)
								? <ContentManagementPage userData={userData} customer={customer} handleContentModalOpen={handleContentModalOpen} permissions={permissions} />
								: page.component == 'ReportAnalyticsPage' && userHasPermission('foresight', permissions)
								? <ReportAnalyticsPage customer={customer} userData={userData} permissions={permissions}/>
								: page.component == 'ForesightPage' && userHasPermission('foresight', permissions)
								? <ForesightPage lang={lang} userData={userData} customer={customer}/>
								: page.component == 'MobilityScore' && userHasPermission('mobilityscore', permissions)
								? <MobilityScore lang={lang} userData={userData} allPermissions={permissions} locations={locations}/>
								: page.component == 'UsersPage' && userData.customer_id === env.ACTIONFIGURE_CUSTOMER_ID
								? <UsersPage lang={lang} customer={customer} />
								: page.component == 'LocationsPage' && userData.customer_id === env.ACTIONFIGURE_CUSTOMER_ID
								? <LocationsPage lang={lang} userData={userData} customer={customer} />
								: page.component == 'CustomersPage' && userData.customer_id === env.ACTIONFIGURE_CUSTOMER_ID
								? <CustomersPage lang={lang} userData={userData} customer={customer} />
								: page.component == 'JourneyPage' && userData.role === 'af_admin'
								? <JourneyPage lang={lang} userData={userData} customer={customer} />
								: page.component == 'JourneyPlaylistPage' && userData.role === 'af_admin'
								? <JourneyPlaylistPage lang={lang} userData={userData} customer={customer} handleContentModalOpen={handleContentModalOpen} permissions={permissions} />
								: <></>
							}
						</Route>
					})}
			</div>
		</div>
	);

};

export default ContentSwitcher
